import { Request, Response } from "express"

export const routeGetOnline = async (_req: Request, res: Response) => {
	res.send(`<h2 style="color: #090;">Calendar API is online!</h2>`)
}
